import EmailService from '@/services/email.service'

export default {
  namespaced: true,
  state: {
    categoria: null,
    categorias: [],
    loading: false,
    error: false
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setCategoria: (state, categoria) => state.categoria = categoria,
    setCategorias: (state, categorias) => state.categorias = categorias
  },
  actions: {
    async ['buscaModelos'](
      { commit }
    ) {
      try {
        commit('setLoading', true)
        const data = await EmailService.modelos()
        commit('setCategorias', data.categorias)
      } catch (error) {
        commit('setError', errr)
      } finally {
        commit('setLoading', false)
      }
    },
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getCategoria: state => state.categoria,
    getCategorias: state => state.categorias,
  }
}
